<template>
  <!-- 1150px -->
  <div style="width:700px">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <div class="">
        <el-form-item>
          <el-input v-model="formInline.keyword" style="width: 165px" placeholder="请输入测评对象名称" @change="changeFormSelect"
            size="small" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.surveyor_id" clearable size="small" @change="changeFormSelect"
            placeholder="请选择测评员" style="width: 135px">
            <el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in surveyors">
              <i class="el-icon-user-solid" v-if="item.id"></i>
              <i class="el-icon-remove-outline" v-else></i>
              {{ item.name }}
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="formInline.status" clearable size="small" style="width: 140px" placeholder="请选择任务状态"
            @change="changeFormSelect">
            <el-option v-for="item in statuses" :key="item" :label="item | taskStatusCn" :value="item">
              <TaskStatus :status="item" />
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.tag_ids" multiple collapse-tags size="small" @change="changeFormSelect"
            @clear="changeFormSelect" style="width: 135px" @remove-tag="changeFormSelect" placeholder="请选择标签" clearable>
            <el-option v-for="item in tagsList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span @click="expand = !expand" class="expand">
            <i class="el-icon-arrow-down" v-if="expand" />
            <i class="el-icon-arrow-up" v-else />
            {{ expand ? "简单搜索" : "高级搜索" }}
          </span>
        </el-form-item>
      </div>

      <div v-if="expand">
        <el-form-item>
          <el-date-picker v-model="formInline.created_between" type="daterange" size="small" style="width: 250px"
            @change="changeFormSelect" @clear="changeFormSelect" range-separator="至" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-select v-model="formInline.evaluation_form_id" clearable size="small" placeholder="请选择测评表"
            @change="changeFormSelect" @clear="changeFormSelect">
            <el-option v-for="item in forms" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getEvaluationFormList } from "@/api/evaluation-form";
import { getSurveyors, getTags } from "@/api/project";
import TaskStatus from "./task-status.vue";
export default {
  data() {
    return {
      formInline: {
        keyword: "",
        status: "",
        surveyor_id: "",
        evaluation_form_id: "",
        tag_ids: [],
        created_between: []
      },
      forms: [],
      surveyors: [],
      tagsList: [],
      statuses: [
        "created",
        "started",
        "ended",
        "uploaded",
        "confirmed",
        "appealing",
        "appealed",
        "reviewing",
        "reviewed",
        "completed"
      ],
      expand: false
    };
  },
  mounted() {
    this.getTagList();
    this.getEvaluationFormList();
    this.getSurveyors();
  },
  components: {
    TaskStatus
  },
  methods: {
    getTagList() {
      let project_id = this.$route.params.id;
      getTags({ project_id }).then((res) => {
        this.tagsList = res.data;
      });
    },
    getEvaluationFormList() {
      let project_id = this.$route.params.id;
      getEvaluationFormList({ project_id }).then((res) => {
        this.forms = res.data;
      });
    },
    changeFormSelect(data) {
      console.log(data);
      this.$emit("formValue", this.formInline);
    },
    getSurveyors() {
      getSurveyors().then((res) => {
        this.surveyors = [{ id: 0, name: "尚未分配" }].concat(res.data);
      });
    }
  }
};
</script>

<style scoped>
.demo-form-inline .el-form-item {
  margin-bottom: 0 !important;
}

.expand {
  color: gray;
  cursor: pointer;
}
</style>
